import * as React from "react";
import { asThemeConsumer } from "../../../theme/Theme";
import { joinClasses } from "../../../utils/Filters";
import { Icon } from "./Icon";
import { isLinkPropsHref } from "./Link";
/**
 *
 * @param theme
 */
var mttc = function (theme) {
    return joinClasses(theme && (theme.paletteState || theme.palette) ? "scl-a-btn" : undefined);
};
/**
 *
 * @param props
 */
var ButtonComp = function (props) {
    var clazzName = joinClasses(props.className, !!props.icon ? "scl-a-btn__icon" : undefined);
    var btnIcon = !!props.icon ? React.createElement(Icon, { name: props.icon }) : undefined;
    var btnLabel = props.label ? props.label : undefined;
    var btnContent = function () { return ((!!btnIcon || btnLabel
        ? (React.createElement(React.Fragment, null,
            btnIcon,
            btnLabel))
        : props.children)); };
    return isLinkPropsHref(props.link)
        ? (React.createElement("a", { style: props.style, className: clazzName, href: props.link.href, target: props.link.target, id: props.id, download: props.link.download }, btnContent()))
        :
            (React.createElement("button", { id: props.id, style: props.style, type: props.buttonType ? props.buttonType : "button", className: clazzName, onClick: !!props.link ? props.link.onClick : undefined, disabled: props.disabled, title: props.title }, btnContent()));
};
/**
 *
 */
export var Button = asThemeConsumer(ButtonComp, mttc);
